export const isMemberHouseholdsResponse = (v) => Boolean(v &&
    typeof v === 'object' &&
    Array.isArray(v.households) &&
    v.households.every((h) => typeof h.id === 'string' && Number.isInteger(h.version) && Array.isArray(h.members)));
export const isHouseholdCatalogsResponse = (v) => Boolean(v && typeof v === 'object' && Array.isArray(v.catalogs));
